import React from "react";

const FilterIndicator = ({
  selectedDay,
  setSelectedDay,
  selectedHour,
  setSelectedHour,
  selectedSport,
  setSelectedSport,
  clearAllFilters,
}) => {
  return (
    <div className="px-5 py-2 bg-gray-50 dark:bg-gray-800 flex flex-wrap gap-2">
      <span className="text-sm text-gray-600 dark:text-gray-300">Filters:</span>

      {selectedDay !== "TODAY" && (
        <span className="text-sm bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded-full flex items-center">
          {selectedDay}
          <button
            className="ml-1 text-blue-500 hover:text-blue-700"
            onClick={() => setSelectedDay("TODAY")}
          >
            ×
          </button>
        </span>
      )}

      {selectedHour && (
        <span className="text-sm bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-2 py-1 rounded-full flex items-center">
          {selectedHour}
          <button
            className="ml-1 text-green-500 hover:text-green-700"
            onClick={() => setSelectedHour(null)}
          >
            ×
          </button>
        </span>
      )}

      {selectedSport && (
        <span className="text-sm bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 px-2 py-1 rounded-full flex items-center">
          {selectedSport}
          <button
            className="ml-1 text-purple-500 hover:text-purple-700"
            onClick={() => setSelectedSport(null)}
          >
            ×
          </button>
        </span>
      )}

      <button
        className="text-sm text-red-600 dark:text-red-400 hover:underline ml-auto"
        onClick={clearAllFilters}
      >
        Clear All
      </button>
    </div>
  );
};

export default FilterIndicator;
